import AsyncStorage from '@react-native-async-storage/async-storage';
import { ICustomAsyncStorage } from './types';

export const CustomAsyncStorage: ICustomAsyncStorage = {
  setItem: async (key: string, value: string): Promise<void> => {
    await AsyncStorage.setItem(key, value);
  },

  removeItem: async (key: string): Promise<void> => {
    await AsyncStorage.removeItem(key);
  },

  getItem: async (key: string): Promise<string | null> => {
    return AsyncStorage.getItem(key);
  },
};
